import React, { useEffect } from 'react';

import mediator from 'Utilities/mediator';

import ModalContainer from 'Components/modal/ModalContainer';
import UnexpectedError from 'Components/utility/UnexpectedError';

type Props = {
  reset: () => void;
};

const CaughtErrorModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  useEffect(() => {
    mediator.publish('modal:show');
  }, []);

  return (
    <ModalContainer>
      <UnexpectedError {...props} />
    </ModalContainer>
  );
};

export default CaughtErrorModal;
